import { FlatRatesTypes } from 'swag-common/constants/shipping.constants';
export function checkIsShippingRateFlat(rate) {
  // @todo. auto generated. fix this error
  // @ts-ignore
  return Object.values(FlatRatesTypes).includes(rate.serviceCode);
}